(function () {
  'use strict';

  // Mirrors snippets/cart-bundle-count.liquid exactly — see that file for
  // why the count isn't just cart.item_count (bundle parent + children +
  // gift lines all inflate it). Kept as a named global (not an IIFE-local
  // closure) so it can be reused/unit-poked from the console while testing.
  //
  // Takes a /cart.js-shaped object (anything with an `items` array of
  // { quantity, properties }) and returns the bundle-aware integer count.
  function bfCartCount(cart) {
    var items = (cart && cart.items) || [];
    var seenSetIds = {};
    var count = 0;

    items.forEach(function (item) {
      var setId = item.properties && item.properties._set_id;
      if (setId) {
        if (!seenSetIds[setId]) {
          seenSetIds[setId] = true;
          count += 1;
        }
      } else {
        count += item.quantity;
      }
    });

    return count;
  }

  window.BFCartCount = bfCartCount;

  var routeRoot = (window.theme && window.theme.routes && window.theme.routes.root) || '/';
  var cartJsUrl = routeRoot + 'cart.js';

  // The theme's own cart-count custom element (assets/theme.js) updates on
  // this same event using cart.item_count-based logic, which is what's
  // wrong here — this listener runs after it (added after page parse, same
  // document-level event) and overwrites its result with the correct
  // bundle-aware number. Also covers the drawer/cart page heading, both of
  // which use the identical <cart-count> element.
  function refresh() {
    fetch(cartJsUrl, { headers: { Accept: 'application/json' } })
      .then(function (res) {
        return res.json();
      })
      .then(function (cart) {
        var count = bfCartCount(cart);

        document.querySelectorAll('cart-count[data-cart-count]').forEach(function (el) {
          var limit = el.getAttribute('data-limit');
          var displayValue = limit && count >= parseInt(limit, 10) ? '9+' : String(count);
          el.setAttribute('data-cart-count', count);
          el.textContent = displayValue;
        });
      })
      .catch(function (error) {
        console.error('[BF cart count] refresh failed', error);
      });
  }

  // theme:cart:change is the theme's existing cart-updated event (fired by
  // CartItems.build() in assets/theme.js after every add/update/remove
  // AJAX round-trip, including the bundle REMOVE link and the sets
  // composer's add-to-cart). Re-running here on every one of those keeps
  // the count correct without a page reload.
  document.addEventListener('theme:cart:change', refresh);
})();
